import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GlobalStyles } from '@/styles/GlobalStyles';
import { ROUTES } from '@/constants/routes';
import { ProtectedRoute } from '@/router/ProtectedRoute';
import { CampaignRouteGuard } from '@/router/CampaignRouteGuard';
import { HomePage } from '@/pages/home';
import { PaywallV1 } from '@/pages/paywall/v1';
import { PaywallV2 } from '@/pages/paywall/v2';
import { PaywallV3 } from '@/pages/paywall/v3';
import { PaywallV4 } from '@/pages/paywall/v4';
import { PaywallV5 } from '@/pages/paywall/v5';
import { LoginPage } from '@/pages/login';
import { LoginCodePage } from '@/pages/login/code';
import { PaymentPage } from '@/pages/payment';
import { AccountSubscription } from '@/pages/account/subscription';
import { PolicyIndex } from '@/pages/policy';
import { PrivacyPolicy } from '@/pages/policy/privacy';
import { TermsOfService } from '@/pages/policy/terms';
import { SubscriptionInfo } from '@/pages/policy/subscription';
import { FeedbackPage } from '@/pages/policy/feedback';
import TestWebViewPage from '@/pages/test-webview';
import { AppsFlyerParamsTracker } from '@/components/providers/AppsFlyerParamsTracker';
import { AttParamsTracker } from '@/components/providers/AttParamsTracker';
import { RouteScrollManager } from '@/components/providers/RouteScrollManager';
import { InstallV1 } from '@/pages/install/v1';
import { PaywallV6 } from '@/pages/paywall/v6';
import { PaywallV7 } from '@/pages/paywall/v7';
import { PaywallV8 } from '@/pages/paywall/v8';
import { PaywallV9 } from '@/pages/paywall/v9';
import { PaymentProcessingOverlay } from '@/components/ui/PaymentProcessingOverlay';
import { WebOnlyCampaignRouteGuard } from '@/router/WebOnlyCampaignRouteGuard';

function App() {
  return (
    <BrowserRouter>
      <GlobalStyles />
      <RouteScrollManager />
      <AppsFlyerParamsTracker />
      <AttParamsTracker />
      <PaymentProcessingOverlay />
      <Routes>
        {/* Home route */}
        <Route path={ROUTES.HOME} element={<HomePage />} />

        {/* Auth routes */}
        <Route path={ROUTES.AUTH.LOGIN} element={<LoginPage />} />
        <Route path={ROUTES.AUTH.LOGIN_CODE} element={<LoginCodePage />} />

        {/* Paywall routes */}
        <Route
          path={ROUTES.PAYWALL.V1}
          element={(
            <CampaignRouteGuard>
              <PaywallV1 />
            </CampaignRouteGuard>
          )}
        />
        <Route
          path={ROUTES.PAYWALL.V2}
          element={<PaywallV2 />}
        />
        <Route
          path={ROUTES.PAYWALL.V3}
          element={(
            <CampaignRouteGuard>
              <PaywallV3 />
            </CampaignRouteGuard>
          )}
        />
        <Route
          path={ROUTES.PAYWALL.V4}
          element={(
            <CampaignRouteGuard>
              <PaywallV4 />
            </CampaignRouteGuard>
          )}
        />
        <Route
          path={ROUTES.PAYWALL.V5}
          element={(
            <CampaignRouteGuard>
              <PaywallV5 />
            </CampaignRouteGuard>
          )}
        />
        <Route
          path={ROUTES.PAYWALL.V6}
          element={(
            <CampaignRouteGuard>
              <PaywallV6 />
            </CampaignRouteGuard>
          )}
        />
        <Route
          path={ROUTES.PAYWALL.V7}
          element={(
            <CampaignRouteGuard>
              <PaywallV7 />
            </CampaignRouteGuard>
          )}
        />
        <Route
          path={ROUTES.PAYWALL.V8}
          element={(
            <WebOnlyCampaignRouteGuard>
              <PaywallV8 />
            </WebOnlyCampaignRouteGuard>
          )}
        />
        <Route
          path={ROUTES.PAYWALL.V9}
          element={(
            <WebOnlyCampaignRouteGuard>
              <PaywallV9 />
            </WebOnlyCampaignRouteGuard>
          )}
        />

        {/* Install routes */}
        <Route
          path={ROUTES.INSTALL.V1}
          element={(
            <CampaignRouteGuard>
              <InstallV1 />
            </CampaignRouteGuard>
          )}
        />

        {/* Payment route */}
        <Route
          path={ROUTES.PAYMENT.INDEX}
          element={(
            <ProtectedRoute>
              <PaymentPage />
            </ProtectedRoute>
          )}
        />

        {/* Policy routes */}
        <Route path={ROUTES.POLICY.INDEX} element={<PolicyIndex />} />
        <Route path={ROUTES.POLICY.PRIVACY} element={<PrivacyPolicy />} />
        <Route path={ROUTES.POLICY.TERMS} element={<TermsOfService />} />
        <Route path={ROUTES.POLICY.SUBSCRIPTION} element={<SubscriptionInfo />} />
        <Route path={ROUTES.POLICY.FEEDBACK} element={<FeedbackPage />} />

        {/* Protected routes */}
        <Route
          path={ROUTES.ACCOUNT.SUBSCRIPTION}
          element={(
            <ProtectedRoute>
              <AccountSubscription />
            </ProtectedRoute>
          )}
        />

        {/* Test WebView route */}
        <Route path={ROUTES.TEST_WEBVIEW} element={<TestWebViewPage />} />

        {/* Default redirect */}
        <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
